import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Image,
  Table,
  Button,
} from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  fetchCurrentPlan,
  updateCurrentPlan,
  fetchPackagesDetail,
  blankCurrentPlan,
} from "../../redux/slices/EnhanceDisputeSlice";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../assets/img/disputely-logo-blue.svg";
import Holding from "../../assets/img/holding-envelope.png";
import BotHead from "../../assets/img/bot-head.png";
import moment from "moment";
import Loader from "../../components/Loader";
import EnhancedFactory from "../../assets/img/disputely-enhanced-factory.png";
import WdfuStandard from "../../assets/img/standard-wd4u.png";
import Joyride from "react-joyride";
import {
  fetchTourProgresses,
  updateTourProgress,
} from "../../redux/slices/TourProgressSlice";

const PaymentConfirmation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { plan } = useParams();
  const [planId, setPlanId] = useState(0);
  const packages = useSelector((state) => state.enhanceDispute.packages);
  const firstName = useSelector((state) => state.enhanceDispute.firstName);
  const packagesDetail = useSelector(
    (state) => state.enhanceDispute.packagesDetail
  );
  const currentPlanStatus = useSelector(
    (state) => state.enhanceDispute.currentPlanStatus
  );

  React.useEffect(() => {
    dispatch(fetchCurrentPlan());
    dispatch(fetchPackagesDetail());
    setPlanId(plan === "standard" ? 1 : 2);

    return () => {
      dispatch(blankCurrentPlan());
    };
  }, []);

  const [currentStep, setCurrentStep] = useState(0);

  const [run, setRun] = React.useState(false);
  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: "var(--bs-dark-blue)", // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: "18px",
      fontWeight: "500",
    },
  };

  const steps = [
    {
      target: ".first-step",
      content: (
        <>
          {" "}
          <p>You made it! Your disputes are being generated as we speak!</p>
          <p>
            Once you click the button below, you will be taken to the Dispute
            Center...
          </p>
          <p>Excited? You should be! Great things are one click away...</p>
        </>
      ),
      disableBeacon: true,
    },
  ];
  // Tour Progresses
  const tourStatus = useSelector((state) => state.tourProgress.status);
  const tours = useSelector((state) => state.tourProgress.tours);

  useEffect(() => {
    if (tourStatus === "idle") dispatch(fetchTourProgresses());
  }, [tourStatus]);

  useEffect(() => {
    if (
      tours.filter(
        (tour) => tour.tour_name === "payment-confirmation" && tour.completed
      ).length === 0
    )
      setRun(true);
    else if (["loading", "idle"].includes(tourStatus)) setRun(false);
    else setRun(false);
  }, [tours, tourStatus]);

  const handleJoyrideCallback = (data) => {
    const { type, status, index, action } = data;
    if (type === "tour:end")
      dispatch(
        updateTourProgress({ tour_name: "payment-confirmation", completed: 1 })
      );
  };

  if (currentPlanStatus === "idle") return <Loader />;

  return (
    <>
      <Helmet>
        <title>Payment Confirmation</title>
      </Helmet>
      <style>{`
      /* Change the button background color */
.react-joyride__tooltip button {
  background-color: #0076FF !important; /* Change this to your desired color */
  border-color: #0076FF !important; /* Change this to your desired color */
}

/* Change the button hover background color */
.react-joyride__tooltip button:hover {
  background-color: #1b1848 !important; /* Change this to your desired hover color */
  border-color: #0076FF !important; /* Change this to your desired hover color */
}

/* Change the button properties */
.react-joyride__tooltip button[type="button"][data-action="back"] {
  appearance: none !important;
background-color: transparent !important;
border-style: none !important;
color: #0076FF !important;
cursor: pointer !important;
font-family: "Anek Bangla", sans-serif !important;
font-size: 16px !important;
font-weight: 400 !important;
line-height: 16px !important;
margin: 0 !important;
margin-right: auto !important;
padding: 8px !important;
text-align: center !important;
text-transform: none !important;
visibility: visible !important;


}

/* Change the button hover properties */
button[type="button"][data-action="back"]:hover {
 color: var(--bs-dark-blue) !important; 
  background-color: none !important; 
  
}

div[style*="align-items: center; display: flex; justify-content: flex-end; margin-top: 15px;"] > div {
  /* Override the style here */
  flex: inherit !important;
}

      `}</style>
      <Container className="mt-5 mb-5">
        <Joyride
          showSkipButton={true}
          locale={{ last: "FINISH" }}
          styles={customJoyrideStyles}
          steps={steps}
          run={run}
          continuous={true}
          scrollToFirstStep={true}
          showProgress={false}
          hideCloseButton
          disableOverlayClose={true}
          disableCloseOnEsc={true}
          callback={handleJoyrideCallback}
        />

        <Row className="d-flex justify-content-center">
          <Col md={4} className="position-relative">
            <Image src={Holding} className="position-absolute w-100" />
          </Col>
          <Col md={8}>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <Image src={Logo} width="150" />
                <div className="py-2">
                  <span className="d-block text-muted">Order Date</span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: moment().format("Do MMMM, YYYY"),
                    }}
                  ></span>
                </div>
              </Card.Header>
              <Card.Body>
                <Card.Title>{firstName}, your order is Confirmed!</Card.Title>
                <Card.Text>
                  <p>
                    Your purchase of{" "}
                    <strong>
                      {plan == "standard"
                        ? "Standard Disputes w/Mailing"
                        : "Enhanced Disputes"}
                    </strong>{" "}
                    is confirmed and you're good to go!
                  </p>
                </Card.Text>
                <Table
                  responsive
                  className="payment border-top mt-3 mb-3 border-bottom"
                >
                  <tbody>
                    {/* ...table content... */}
                    <tr>
                      <td></td>
                      {/* ...more table content... */}
                    </tr>
                  </tbody>
                </Table>
                <Table responsive className="product border-bottom">
                  <tbody>
                    {/* ...table content... */}
                    <tr>
                      <td width="20%">
                        <Image
                          src={
                            plan === "standard" ? WdfuStandard : EnhancedFactory
                          }
                          width="300"
                        />
                      </td>
                      <td>
                        <div className="text-regular-16">
                          {plan === "standard" ? (
                            <h5>
                              Expedited Processing & Mailing w/ Dispute.ly{" "}
                            </h5>
                          ) : (
                            <h5>
                              Enhanced Disputes + Expedited Processing & Mailing
                              w/ Dispute.ly{" "}
                            </h5>
                          )}

                          <p className="mb-0" style={{ fontWeight: "400" }}>
                            {packagesDetail.length > 0 &&
                              packagesDetail[planId - 1]?.total_negative}{" "}
                            Negative items
                          </p>
                          <p className="mb-0" style={{ fontWeight: "400" }}>
                            {packagesDetail.length > 0 &&
                              packagesDetail[planId - 1]
                                ?.total_destination}{" "}
                            Destinations
                          </p>
                          <p className="mb-0" style={{ fontWeight: "400" }}>
                            {packagesDetail.length > 0 &&
                              packagesDetail[planId - 1]?.total_letter}{" "}
                            Total letters
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <Row className="d-flex justify-content-end">
                  <Col md={5}>
                    <Table className="totals">
                      <tbody>
                        {/* ...table content... */}
                        <tr>
                          <td>
                            <div className="text-left">
                              <span className="text-muted">Subtotal</span>
                            </div>
                          </td>
                          <td>${packages[planId]}</td>
                          {/* ...more table content... */}
                        </tr>
                        <tr>
                          <td>
                            <div className="text-left">
                              <span className="text-muted">Total</span>
                            </div>
                          </td>
                          <td>${packages[planId]}</td>
                          {/* ...more table content... */}
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <Card.Text className="mt-5 text-end">
                  <p>
                    We will be sending shipping confirmation email when the item
                    shipped successfully!
                  </p>
                  <p className="font-weight-bold mb-0">
                    Thanks for shopping with us!
                  </p>
                  <span>The Disputely Team</span>
                </Card.Text>
              </Card.Body>
              <Card.Footer className="d-flex justify-content-between">
                <span>
                  Have Questions? Visit our{" "}
                  <Link to={"/help"}>help center</Link>
                </span>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="nx-auto d-flex">
            <Button
              variant="primary ms-auto px-5 py-3 w-40 mt-5 first-step"
              onClick={() =>
                navigate("/dispute-center", {
                  replace: true,
                  state: {
                    congratulations: true,
                  },
                })
              }
              className="px-5 mx-auto"
              type="submit"
              size="lg"
            >
              Take Me to My Dispute Center!
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PaymentConfirmation;
